import type { ReactElement } from 'react'

import vantaLogo from '@/assets/vanta-logo.png'
import { cn } from '@/lib/cn'

interface MarketingBrandProps {
  className?: string
  eager?: boolean
}

export function MarketingBrand({ className, eager = false }: MarketingBrandProps): ReactElement {
  return (
    <span className={cn('inline-flex items-center gap-2 text-lg font-semibold tracking-tight', className)}>
      <img
        src={vantaLogo}
        alt="VantaCMD"
        width={32}
        height={32}
        loading={eager ? 'eager' : 'lazy'}
        className="h-8 w-8 rounded-lg"
      />
      VantaCMD
    </span>
  )
}
